import React from 'react';

const PaymentPending = () => {
  return (
   <div className="container text-center p-5">
  <h1>⏳ Payment Pending</h1>
  <p>Your payment is being reviewed. We will notify you once it’s confirmed.</p>
</div>
  );
};

export default PaymentPending;
